// extracted by mini-css-extract-plugin
export default {"root":"r9Q46chrhMAAlSCCTFuw","hidden":"FsVVZ5T5nesTxydY1m0T"};